module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "gra2pes.add3de04.png";